
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { ApiService } from '../core/api.service';
import { AppState } from '../../../store/app-state';
import { userLoginAction, userSetTokenAction, userClearTokenAction, userLogoutAction } from '../../../store/user/index';
import { RouterService } from '../core/router.sevice';
import { loadingService } from '../loading.service';

@Injectable()
export class AccountService {

  constructor(
    private store: Store<AppState>,
    private routerService: RouterService,
    private apiService: ApiService,
    private loadingService: loadingService,
  ) {
  }



  register(payload: { email: string, password: string, passwordRepeat: string }) {
    this.loadingService.showLoading();
    return this.apiService.send('user/register', payload)
      .then(result => {
        this.loadingService.closeLoading();
        return result;
      })
  }

  login(payload: { email: string, password: string }) {
    this.loadingService.showLoading();
    return this.apiService.authenticate(payload)
      .then(result => {
        this.loadingService.closeLoading();
        if(result.error == undefined)
        {
          this.apiService.send('user/getbyemail/', { email: payload.email })
          .then(result2 => {
            this.store.dispatch(userSetTokenAction(result.access_token))
            this.store.dispatch(userLoginAction({ id: result2, email: payload.email }));
            this.routerService.go('/');
            return result;
          })
        }
        else
        {
          return result;
        }
      })
      .catch(result => {
        return result;
      })
  }

  verificar(email: string, codigo: string) {
    this.loadingService.showLoading();
    return this.apiService.send('user/verificar', { email: email, code: codigo })
      .then(result => {
        this.loadingService.closeLoading();
        return result;
      })
  }

  reenviarCorreo(email: string)
  {
    this.loadingService.showLoading();
    return this.apiService.send('user/reenviarCorreo', { email: email, code: "" })
      .then(result => {
        this.loadingService.closeLoading();
        return result;
      })
  }

  sendCode(email: string) {
    this.loadingService.showLoading();
    return this.apiService.send('user/sendCode', { email: email })
      .then(result => {
        this.loadingService.closeLoading();
        return result;
      })
  }

  recover(payload: any) {
    this.loadingService.showLoading();
    return this.apiService.send('user/recover', payload)
      .then(result => {
        this.loadingService.closeLoading();
        return result;
      })
  }

  logut() {
    this.loadingService.showLoading();
    this.store.dispatch(userLogoutAction());
    this.store.dispatch(userClearTokenAction());
    //this.routerService.go('/account');
    //this.routerService.go('/');
    location.hash = "/";
    location.reload(true);
    
    this.loadingService.closeLoading();
  }

  finish() {
    this.loadingService.showLoading();
    this.store.dispatch(userLogoutAction());
    this.store.dispatch(userClearTokenAction());
    //this.routerService.go('/account');
    this.loadingService.closeLoading();
    location.reload(true);
    this.routerService.go('/');
  }

  reload()
  {
    this.loadingService.showLoading();
    this.store.dispatch(userLogoutAction());
    this.store.dispatch(userClearTokenAction());
    this.routerService.go('/');
    this.loadingService.closeLoading();
  }

  refresh()
  {
    this.loadingService.showLoading();
    this.store.dispatch(userLogoutAction());
    this.store.dispatch(userClearTokenAction());
    location.reload(true);
  }

  confirm(payload: string)
  {
    this.loadingService.showLoading();
    return this.apiService.send('user/validate/' + payload, payload)
    .then(result => {
      this.loadingService.closeLoading();
      return result;
    })

  }



}



// WEBPACK FOOTER //
// ./src/app/core/service/app/account.service.ts